import {styled} from "styled-components";
import AppleSvg from "bootstrap-icons/icons/apple.svg?react";
import {Trans, useTranslation} from "react-i18next";

const Badge = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #000;
  color: #fff;
  border-radius: 8px;
  padding: 0 10px;
  text-decoration: none;
  height: 42px;
  width: 135px;
  &:hover {
    background: #222;
  }
`;

const StyledAppleLogo = styled(AppleSvg)`
  height: 26px;
  flex-shrink: 0;
`;

const BadgeText = styled.span`
  color: #fff;
  text-align: left;
  display: flex;
  flex-direction: column;
  font-family:
    -apple-system,
    BlinkMacSystemFont,
    Segoe UI,
    Noto Sans,
    Roboto,
    Helvetica Neue,
    Arial,
    sans-serif,
    Apple Color Emoji,
    Segoe UI Emoji,
    Segoe UI Symbol,
    Noto Color Emoji;
  white-space: nowrap;
  line-height: 1;
  gap: 2px;
`;

const BadgeSmall = styled.span`
  font-size: 10px;
`;

const BadgeLarge = styled.span`
  font-size: 18px;
  font-weight: bold;
`;

export const OpenInSafariBadge = ({href}: {href: string}) => {
  const {t} = useTranslation("landing");
  return (
    <Badge href={href}>
      <StyledAppleLogo />
      <BadgeText>
        <BadgeSmall>
          <Trans i18nKey="sec1.open-in" t={t}>
            Open in
          </Trans>
        </BadgeSmall>
        <BadgeLarge>Safari</BadgeLarge>
      </BadgeText>
    </Badge>
  );
};
